// A round has a Team of the Round once one has been saved for it; the API's `status` is 1 then.
export const isSetUp = (round) => round?.status === 1
